/**
 * Labeled select built on MUI FormControl.
 */
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { asArray, asFunc, asString } from "utils/safeData";

/**
 * Dropdown that translates option labels and reports the selected value.
 *
 * @param {{ option?: string|number, setOption?: Function, label?: string, items?: Array<{ label: *, value: * }>, variant?: string, inputClassName?: string }} props
 */
const VSelect = (props) => {
  const { t } = useTranslation("common");

  const { option, setOption: rawSetOption, label, items: rawItems, variant, inputClassName = "", ...rest } = props;
  const items = asArray(rawItems);
  const setOption = asFunc(rawSetOption);

  return (
    <>
      {items.length > 0 && (
        <FormControl variant={variant} {...rest}>
          <InputLabel id="demo-simple-select-label">{asString(label)}</InputLabel>
          <Select labelId="demo-simple-select-label" id="demo-simple-select" value={option} label={label} onChange={(e) => setOption(e.target.value)} inputProps={{ className: inputClassName }}>
            {items.map((v) => (
              <MenuItem key={v.value} value={v.value}>
                {t(v.label)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
};

VSelect.defaultProps = {
  option: "",
  setOption: () => {},
  items: [],
  label: "",
  variant: "outlined", // filled, standard
};

VSelect.propTypes = {
  option: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setOption: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.any, value: PropTypes.any })),
  label: PropTypes.string,
  variant: PropTypes.string,
  inputClassName: PropTypes.string,
};

export default VSelect;
